<div class="banktransfer-info" [class.open]="step === 'banktransfer'" *ngIf="(donation.amount + donation.extraAmount) > 0 && donation.paymentMethod == 'banktransfer' && (step == 'thankyou' || step == 'banktransfer')">
	<div *ngIf="step != 'banktransfer'" class="row">
		<div class="columns small-12 medium-8 medium-centered">
			<submit [text]="'banktransfer.button.open' | translate" (click)="showData()" [additionalClasses]="'hollow'"></submit>
		</div>
	</div>
	<div *ngIf="step == 'banktransfer'">
		<div class="row">
			<div class="columns small-12">
				<p class="teaser">{{ 'banktransfer.teaser' | translate }}</p>
			</div>
		</div>

		<div class="row">
			<div class="columns small-12">
				<div class="row">
					<div class="columns small-12">
						<copyfield [label]="'banktransfer.receiver.label'" [value]="donation.paymentBanktransfer.receiverName"></copyfield>
					</div>
					<div class="columns small-12">
						<copyfield [label]="'banktransfer.iban.label'" [value]="getFormattedIBAN()" [copyValue]="donation.paymentBanktransfer.receiverIban"></copyfield>
					</div>
					<div class="columns small-6 medium-12">
						<copyfield [label]="'banktransfer.subject.label'" [value]="donation.paymentBanktransfer.paymentReferenceMessage"></copyfield>
					</div>
					<div class="columns small-6 medium-8">
						<copyfield [label]="'banktransfer.amount.label'" [value]="getAmount()"></copyfield>
					</div>
					<div class="columns small-6 medium-4">
						<div class="copyfield-dummy">{{ donation.currency }}</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
